﻿import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Pedido, Producto, Item } from 'src/app/_models';
import { RestService } from 'src/app/_services/rest.service';


@Component({ templateUrl: 'anonima.component.html' })
export class AnonimaComponent implements OnInit {

    pedido: Pedido;

    error: boolean = false;

    monetizada: boolean = false;

    constructor(private route: ActivatedRoute, private restService: RestService) {
    }

    ngOnInit() {
        this.error = false;
        this.route.queryParams.subscribe(params => {
            if (params['pedido']) {
                this.pedido = JSON.parse(params['pedido']);
            } else if (params['code']) {
                this.restService.getAll('/rest-api/public/producto').subscribe(
                    data => {
                        this.decode(params['code'], data);
                    }
                );
            } else {
                this.error = true;
            }
        });
    }

    decode(code: string, productos: Array<Producto>) {
        if (code.length > 0) {
            let txt = '';
            const json = JSON.parse(window.atob(code));
            const p = new Pedido();
            p.de = json.de;
            p.mensaje = json.mensaje;
            const items: Array<Item> = [];
            json.items.forEach(it => {
                const prod: Producto = productos.filter(x => x.id === it.producto.id)[0];
                const item: Item = new Item(prod, it.cantidad);
                item.precio = prod.precio;
                items.push(item);
            });
            p['items'] = items;
            this.pedido = p;
        } else {
            this.error = true;
        }
    }


}
